var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9,
    r: 9,
    fill: "#00A0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63226 7.93783L7.61079 11.6389L7.61079 11.6389C7.60976 11.8127 7.46839 11.9541 7.29458 11.9551L6.79167 11.958L6.79166 11.958L6.79108 11.858L7.63226 7.93783ZM7.63226 7.93783L11.7742 12.0797C11.8977 12.2033 12.0975 12.2009 12.2204 12.078L12.5781 11.7203C12.701 11.5974 12.7034 11.3976 12.5799 11.2741L8.43795 7.13215L12.139 7.11066C12.3128 7.10965 12.4542 6.96827 12.4552 6.79446V6.79445L12.4581 6.29153C12.4591 6.11681 12.318 5.97567 12.1433 5.97666H12.1433L6.82387 6.00756C6.65006 6.00857 6.50869 6.14996 6.50766 6.32376L6.50766 6.32377L6.4768 11.6431C6.4768 11.6431 6.4768 11.6431 6.4768 11.6431L7.63226 7.93783Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPay);
export default __webpack_public_path__ + "static/media/request-pay.c947351e2c91fe0050cc37648f2f86f3.svg";
export { ForwardRef as ReactComponent };